/**
 * NOTE!!!
 * This file is listed in webpack as a side-effect import, Ie. the init here is run as part of bootstrapping.
 */
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-locize-backend'
// @ts-ignore
import locizeEditor from 'locize-editor'
import moment from 'moment-timezone'
import { initReactI18next } from 'react-i18next'

// types
import { InitOptions } from 'i18next'

const isDev = process.env.NODE_ENV === 'development'

const lego = window.lego

const config: InitOptions = {
  appendNamespaceToMissingKey: true,
  backend: {
    apiKey: lego.config.LOCIZE_API_KEY,
    onSaved: locizeEditor.handleSavedMissing,
    projectId: '30863896-5fce-480e-90b7-df3857a7a9d1',
    referenceLng: 'en',
  },
  debug: isDev,
  defaultNS: 'WEBSITE',
  detection: {
    // keys or params to lookup language from
    lookupQuerystring: 'locale',
    lookupCookie: 'locale',
    lookupLocalStorage: 'locale',
    lookupSessionStorage: 'locale',
  },
  editor: {
    mode: 'iframe',
    // relode when locize edit translations
    // caveat: this only works when the paragraph is first clicked and found in the editor.
    // https://github.com/locize/locize-editor/issues/17
    onEditorSaved: () => window.location.reload(),
  },
  // set fallbackLng in dev as it's needed in order for the save missing functionality to work
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
    format: (value, format) => {
      if (value instanceof Date) {
        return moment(value).format(format)
      }
      if (moment.isMoment(value)) {
        return value.format(format)
      }
      return value
    },
  },
  keySeparator: false,
  ns: 'WEBSITE',
  nsSeparator: false,
  saveMissing: isDev,
}

i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)

  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)

  // pass the i18n instance to react-i18next.
  .use(initReactI18next)

  // enable the iframed inline editor (show by adding ?locize=true ).
  .use(locizeEditor)

  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init(config)

export default i18n
